import { render, staticRenderFns } from "./mid-tab.vue?vue&type=template&id=dba34fc0"
import script from "./mid-tab.vue?vue&type=script&lang=js"
export * from "./mid-tab.vue?vue&type=script&lang=js"
import style0 from "./mid-tab.vue?vue&type=style&index=0&id=dba34fc0&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports